import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

// Components
import AdminIcon from './AdminIcon';

// Config
import { ROUTES } from '../../../routes/routes';

// Styles
import styles from './styles.module.scss';

const AdminPageLink = ({ className }) => {
  return (
    <NavLink to={ROUTES.adminPage.path} className={classNames(styles.adminLink, className)}>
      <AdminIcon />
    </NavLink>
  );
};

export default AdminPageLink;
